import { combineReducers } from "redux";
import session from "./session";
import cached from "./cached";
import page from "./page";
import profile from "./profile";
import user from "./user";
import site from "./site";
import groups from "./groups";
import organisation from "./organisation";
import unit from "./unit";
import slot from "./slot";
import events from "./events";
import status from "./status";
import option from "./option";
import notes from "./notes";
import name from "./name";
import operation from "./operation";
import upgrade from "./upgrade";
import notifications from "./notifications";
import network from "./network";
import dashboard from "./dashboard";
import tariff from "./tariff";
import audit from "./audit";
import ownerNotification from "./ownerNotification";
import vpp from "./vpp";
import report from "./report";
import version from "./version";
import photos from "./photos";
import modemUsage from "./modemUsage";
import unitUpgradeVersion from "./unitUpgradeVersion";
import vppUserRegistration from "./vppUserRegistration";

const rootReducer = combineReducers({
  session,
  cached,
  page,
  profile,
  user,
  site,
  groups,
  organisation,
  unit,
  slot,
  events,
  status,
  option,
  notes,
  name,
  operation,
  upgrade,
  notifications,
  network,
  dashboard,
  tariff,
  audit,
  ownerNotification,
  vpp,
  report,
  version,
  photos,
  modemUsage,
  unitUpgradeVersion,
  vppUserRegistration,
});

export default rootReducer;
